import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from "react-router-dom";
import { BASE_URL } from '../config';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getSettingData } from '../Redux/ActionCreater';
import Modal from './Modal';
function  Header() {
  let domNode = useRef();
const [data,setData]=useState();
const [page,setPage]=useState();
const [modal,setModal]=useState(false);
  let navigate = useHistory();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => (
       state.dataReducer
    ),
    shallowEqual
  );
  useEffect(() => {
  fetchData();
  }, [])
  let fetchData=()=>{
    let header={
      headers:{
      "X-Auth-Token":"12345"
    }};
    dispatch(getSettingData(header));
  }
  useEffect(() => {
   setData(state.settingData);
   setPage(state.currentPage)
   }, [state])
  
  let lastScrollTop = 0;
  document.addEventListener("scroll", function(e){ 
    let header = document.querySelector('.headercontainer')
    let st = window.pageYOffset || document.documentElement.scrollTop; 
    if (st > lastScrollTop){
      if(window.pageYOffset > 0){
        header.classList.add('sticky'); 
     }
     if(window.pageYOffset > 500){
         header.classList.add('sticky-hide');
     }
     } else {
       if(window.pageYOffset == 0){
          header.classList.remove('sticky'); 
       }else {
          header.classList.remove('sticky-hide');
       }
     }
     lastScrollTop = st <= 0 ? 0 : st; 
  }, false);


  const openNav=()=>{
    document.body.classList.toggle("layout-expanded2");
  }
  const closeMenu=()=>{
    if(document.body.classList.contains("layout-expanded2")){
      document.body.classList.remove("layout-expanded2");
    }
  }
  useEffect(() => {
    let maybeHandler = (event) => {
      if (!domNode.current.contains(event.target)&&!event.target.classList.contains("icon")) {
        document.body.classList.remove("layout-expanded2");
      }
    };

    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });
  const openModal=(e)=>{
    e.preventDefault();
    setModal(true);
    document.body.classList.add("modal-open");
    
  }
  const closeModal=(e)=>{
    e.preventDefault();
    setModal(false);
    document.body.classList.remove("modal-open");
    
  }
  return (
    <>
    <header className="headercontainer">
  <div className="container">
    <div className="row m-0 align-items-center">
      <div className="logoouter">
        <div className="logo" >
          <a href="/" onClick={(e)=>{e.preventDefault(); navigate.push("/")}}>
            {/* <img src={`${BASE_URL}/${data?.logo}`} alt=""/> */}
           {data&& <LazyLoadImage
      alt={""}
      src={`${BASE_URL}/${data?.logo}`}
     width={145}
     height={119}
      />}
            </a>
        </div>
      </div>
      <div className="navigation">
        <div className="topmailbx">
          <a href={`tel:${data?.site_phone_number}`}><i className="icon icon-phone"></i><span>{data?.site_phone_number}</span></a>
          <a href={`mailto:${data?.site_email}`}><i className="icon icon-envelope"></i><span>{data?.site_email}</span></a>
        </div>
        <div  className="navigationouter">
          <div ref={domNode} id="navigationbox" className="navigationbox">
            <div className="navuser">
              <div className="userimg" onClick={(e)=>{e.preventDefault(); navigate.push("/");closeMenu()}}>
              {data&&<LazyLoadImage
      alt={""}
      src={`${BASE_URL}/${data?.logo}`} 
      width={145}
      height={119}
      />}
          
              </div>
              <h3>CNC Machine</h3>
              <p>Maintenance Coach</p>
            </div>
            <div className="sf-menu-outer">
              <ul className="sf-menu">
                <li className={page==="home"?"active":""}><a href="/" onClick={(e)=>{e.preventDefault();navigate.push("/");closeMenu()}}>Home</a></li>
                <li className={page==="about"?"active":""}><a href="/about-me" onClick={(e)=>{e.preventDefault();navigate.push("/about-me");closeMenu()}}>About Us</a></li>
                <li className={page==="course"?"active":""}><a href="/course" onClick={(e)=>{e.preventDefault();navigate.push("/course");closeMenu()}}>Course</a></li>
                <li className={page==="contact"?"active":""} ><a href="/contact-us" onClick={(e)=>{e.preventDefault();navigate.push("/contact-us");closeMenu()}}>Contact Us</a></li>
              </ul>
            </div>
          </div>
          <div className="loginbtx">
            <a className="loginbtn" style={{cursor:"pointer"}} onClick={openModal}><span>Register and Book</span><i className="icon icon-long-arrow-right"></i></a>
          </div>
          <a className="NavBar"  href="" onClick={(e)=>{e.preventDefault();openNav()}}><i className="icon icon-segment"></i></a>
        </div>
      </div>
    </div>
  </div>
</header>
    {modal&&<Modal close={closeModal} data={data}/>}
    </>
  )
}

export default Header